import { render, staticRenderFns } from "./PDFJSViewer.component.vue?vue&type=template&id=4684e346&scoped=true"
import script from "./PDFJSViewer.component.vue?vue&type=script&lang=js"
export * from "./PDFJSViewer.component.vue?vue&type=script&lang=js"
import style0 from "./PDFJSViewer.component.vue?vue&type=style&index=0&id=4684e346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4684e346",
  null
  
)

export default component.exports